export const recalculateVh = () => {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  
    window.onresize = function (event) {
      setTimeout(function () {
        const height =
                  document.documentElement.clientHeight > window.innerHeight
                    ? document.documentElement.clientHeight
                    : window.innerHeight
        vh = height * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      }, 500)
    }
  }